import { useState, useEffect } from 'react';

function usePersistedState(key, defaultValue) {
    const [state, setState] = useState(() => {
        try {
            const stored = sessionStorage.getItem(key);
            if (stored === null) return defaultValue;
            return JSON.parse(stored);
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(state));
        } catch {
            // sessionStorage not available
        }
    }, [key, state]);

    return [state, setState];
}

export default usePersistedState;
